// react
import React from "react";
import { useDispatch } from "react-redux";
import { GenerateProcess } from "redux-process";

// dependencies
import PropTypes from "prop-types";

// components
import Button from "Components/Button";
import Modal from "Components/Modal";

// styles
import css from "./CancelConfirmation";

const CancelConfirmModal = (props) => {
	// Info should have all the info to confirm all
	const { handleClose, companyID } = props;
	const dispatch = useDispatch();

	const handleCancelInvoice = async () => {
		// If Yes then we need to cancel Invoice else close
		await dispatch(GenerateProcess("CancelCompanyInvoice", { companyID }));
		handleClose();
		window.location.reload(false);
	};

	const content = (
		<div className={css.modalContent}>
			<p>Are you sure you want to cancel this invoice?</p>
		</div>
	);

	const buttons = (
		<div>
			<div className={css.cancelConfirmModalButtons}>
				<div className={css.modalButton}>
					<Button version={2} color="green" onClick={handleCancelInvoice}>
						Yes
					</Button>
				</div>
				<div className={css.modalButton}>
					<Button version={2} color="red" onClick={handleClose}>
						Close
					</Button>
				</div>
			</div>
		</div>
	);

	return <Modal content={content} buttons={buttons} handleClose={handleClose} />;
};

CancelConfirmModal.propTypes = {
	handleClose: PropTypes.func.isRequired,
	companyID: PropTypes.string.isRequired,
};

export default CancelConfirmModal;
